export default __webpack_public_path__ + "static/media/nikhita.1eb62573.jpeg";